export const initialVal = {
    isAuth: false,
    token: null,
    loading: false,
    error: ""
}
